(() => {
  if (window.AlmondGrazaVideo) { window.AlmondGrazaVideo.mount(document); return; }
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const videos = [...root.querySelectorAll('[data-gs-video]')];
    const sync = () => {
      videos.forEach(video => {
        video.muted = true;
        if (reduced.matches || document.hidden || video.dataset.visible !== 'true') video.pause();
        else {
          if (!video.getAttribute('src')) { video.src = video.dataset.src; video.load(); }
          video.play()?.catch(() => {});
        }
      });
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); }); sync();
    }, { threshold: .08 }) : null;
    videos.forEach(video => {
      video.muted = true; video.defaultMuted = true; video.removeAttribute('autoplay');
      if (observer) observer.observe(video); else video.dataset.visible = 'true';
    });
    document.addEventListener('visibilitychange', sync, { signal: controller.signal });
    reduced.addEventListener('change', sync);
    sync();
    instances.set(root, () => {
      controller.abort(); observer?.disconnect(); reduced.removeEventListener('change', sync);
      videos.forEach(v => v.pause()); instances.delete(root);
    });
  }
  const mount = scope => { if (scope.matches?.('[data-graza-story]')) init(scope); scope.querySelectorAll('[data-graza-story]').forEach(init); };
  window.AlmondGrazaVideo = { mount };
  mount(document);
  document.addEventListener('shopify:section:load', e => mount(e.target));
  document.addEventListener('shopify:section:unload', e => instances.forEach((destroy, root) => { if (e.target === root || e.target.contains(root)) destroy(); }));
})();
